/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Convert_To_Pop_OnInputs */



/**
* | output |
* | --- |
* | "Convert to Pop-On" |
*
* @param {Convert_To_Pop_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert_to_pop_on = /** @type {((inputs?: Convert_To_Pop_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Convert_To_Pop_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Convertir en pop-up")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Pop-On umstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Converti in Pop-On")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразовать в Pop-On")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir a Pop-On")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转换为弹出式窗口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ポップオンに変換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पॉप-ऑन में बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter para Pop-On")
	return /** @type {LocalizedString} */ ("Convert to Pop-On")
});